module.exports = __webpack_public_path__ + "img/float-btn-cockfigh.838bf518.svg";